import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const StyledImage = styled.img`
    width: ${token('space.300', '24px')};
    height: ${token('space.300', '24px')};
    object-fit: contain;
`;
